$(window).on('load', function() {
  "use strict";

  // menu js
  $('.megamenu-li').parent('ul').parent('.dropdown-submenu').addClass('mega-menu');
  $('.menu-banner').parent('ul').parent('.dropdown-submenu').addClass('banner-menu');
  $('.submenu-li').parent('ul').parent('.dropdown-submenu').addClass('sub-menu');

  // vegamenu
  $('.megamenu-li').parent('ul').addClass('mega-menu');
  $('.menu-banner').parent('ul').addClass('banner-menu');
  $('.submenu-li').parent('ul').addClass('sub-menu');

  // toggler
  $("button.navbar-toggler").click(function(){
    $(".main-menu-area").addClass("active");
    $(".mm-fullscreen-bg").addClass("active");
    $("body").addClass("hidden");
  });
  $(".close-box").click(function(){
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });
  $(".mm-fullscreen-bg").click(function(){
    $(".main-menu-area").removeClass("active");
    $(".mm-fullscreen-bg").removeClass("active");
    $("body").removeClass("hidden");
  });

  // minicart js
  $(".shopping-cart a.cart-count").click(function(){
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
  });
  $(".shopping-cart-close i").click(function(){
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
  });
  $(".mm-fullscreen-bg").click(function(){
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
  });

  // add to cart js via product show mini-cart
  $(".shopping-cart a.cart-count").on('click', function() {
    $(".mini-cart").addClass("show");
    $(".mm-fullscreen-bg").addClass("active");
  });
  $(".shopping-cart-close i").on('click', function() {
    $(".mini-cart").removeClass("show");
    $(".mm-fullscreen-bg").removeClass("active");
     $("body").removeClass("hidden");
  });
   $(".ajax-spin-cart").on('click', function() {
    window.setTimeout(function() {
      $(".mini-cart").addClass("show");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
    }, 1000);
  });

  $('[data-toggle="tooltip"]').tooltip();

  // Sidebar Search Active
  function sidebarSearch() {
    var searchTrigger = $('.trigger-search'),
    endTriggersearch = $('button.search-close'),
    container = $('.main-search-active');
    searchTrigger.on('click', function() {
      container.addClass('inside');
    });
    endTriggersearch.on('click', function() {
      container.removeClass('inside');
    });
  };
  sidebarSearch();

  // Brand Slider
  var blogSlider = $('.blog-image-slider');
  blogSlider.slick({
    arrows: true,
    autoplay: false,
    dots: false,
    pauseOnFocus: true,
    pauseOnHover: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScoll: 1,
    prevArrow: '<button type="button" class="slick-prev"><i class="icon-arrow-left"></i></button>',
    nextArrow: '<button type="button" class="slick-next"><i class="icon-arrow-right"></i></button>',
  });

  // vertical-product-active
  $('.vartical-product-active').slick({
    slidesToShow: 3,
    autoplay: false,
    vertical:true,
    verticalSwiping:true,
    slidesToScroll: 1,
    prevArrow:'<i class="fa fa-angle-up"></i>',
    nextArrow:'<i class="fa fa-angle-down"></i>',
    button:false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    { breakpoint: 991,
      settings: {
        slidesToShow: 3,
        vertical:false,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
        vertical:false,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
        vertical:false,
      }
    }
    ]
  });
  $('.vartical-product-active a').on('click', function () {
    $('.vartical-product-active a').removeClass('active');
  });

  // vertical-product-active
  $('.horizantal-product-active').slick({
    slidesToShow: 4,
    autoplay: false,
    vertical:false,
    prevArrow:'<i class="icon-arrow-top arrow-prv"></i>',
    nextArrow:'<i class="icon-arrow-bottom arrow-next"></i>',
    button:false,
    responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
      }
    },
    { breakpoint: 991,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 3,
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 3,
      }
    }
    ]
  });
  $('.horizantal-product-active a').on('click', function () {
    $('.horizantal-product-active a').removeClass('active');
  });
  $('[data-toggle="tooltip"]').tooltip();

  // Magnific Popup
  $('.product-main-img').magnificPopup({
    delegate: 'a',
    type: 'image',
    showCloseBtn: true,
    closeBtnInside: false,
    midClick: true,
    tLoading: 'Loading image #%curr%...',
    mainClass: 'mfp-img-mobile',
    gallery: {
      enabled: true,
      navigateByImgClick: true,
  preload: [0,1] // Will preload 0 - before current, and 1 after the current image
  },
  image: {
    tError: '<a href="%url%">The image #%curr%</a> could not be loaded.'
  }
  });

  // back to top
  $(window).scroll(function(){
    if ($(this).scrollTop() > 1000) {
      $('#top').fadeIn();
    } else {
      $('#top').fadeOut();
    }
  });
  $('#top').click(function(){
    $("html, body").animate({ scrollTop: 0 }, 600);
    return false;
  });

  // sticky header
  $(window).scroll(function() {
    var sticky = $('.header-area'),
    scroll = $(window).scrollTop();
    if (scroll >= 150) {
      sticky.addClass('is-sticky');
    }
    else {
      sticky.removeClass('is-sticky');
    }
  });

  // video
  $('.play-button, .popup-vimeo, .popup-gmaps').magnificPopup({
    tClose: 'Close (Esc)',
    type: 'iframe',
    mainClass: 'mfp-fade',
    removalDelay: 160,
    preloader: false,
    fixedContentPos: false
  });
  
});